export default __webpack_public_path__ + "KaTeX_Main-Regular.af7fc7b32dbf2a640c9c26b2a0a7d050.ttf";